import React from "react";
import TopButton from "../TopButton/TopButton";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer d-flex align-items-center justify-content-center mt-4 pt-4 mb-5">
      <TopButton></TopButton>
      <div className="text-center footer-title">
        <h6>Copyright © 2023 Lukman Hossain | All Rights Reserved</h6>
      </div>
    </div>
  );
};

export default Footer;
